/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ICreateSingleSystemSetupParameter } from './ICreateSingleSystemSetupParameter';
import {
    ICreateSingleSystemSetupParameterFromJSON,
    ICreateSingleSystemSetupParameterFromJSONTyped,
    ICreateSingleSystemSetupParameterToJSON,
} from './ICreateSingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface CreateTaskItemQaEquipmentSetupDto
 */
export interface CreateTaskItemQaEquipmentSetupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {Array<ICreateSingleSystemSetupParameter>}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    singleSetupParameters?: Array<ICreateSingleSystemSetupParameter> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskItemQaEquipmentSetupDto
     */
    $type?: CreateTaskItemQaEquipmentSetupDtoTypeEnum;
}


/**
 * @export
 */
export const CreateTaskItemQaEquipmentSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateTaskItemQaEquipmentSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateTaskItemQaEquipmentSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateTaskItemQaEquipmentSetupDtoTypeEnum = typeof CreateTaskItemQaEquipmentSetupDtoTypeEnum[keyof typeof CreateTaskItemQaEquipmentSetupDtoTypeEnum];



/**
 * Check if a given object implements the CreateTaskItemQaEquipmentSetupDto interface.
 */
export function instanceOfCreateTaskItemQaEquipmentSetupDto(value?: unknown): value is CreateTaskItemQaEquipmentSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateTaskItemQaEquipmentSetupDtoTypeEnum)[0];
}

export function CreateTaskItemQaEquipmentSetupDtoFromJSON(json: any): CreateTaskItemQaEquipmentSetupDto {
    return CreateTaskItemQaEquipmentSetupDtoFromJSONTyped(json, false);
}

export function CreateTaskItemQaEquipmentSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskItemQaEquipmentSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'supportSystemEntityIds': json['supportSystemEntityIds'] == null ? undefined : json['supportSystemEntityIds'],
        'singleSetupParameters': json['singleSetupParameters'] == null ? undefined : ((json['singleSetupParameters'] as Array<any>).map(ICreateSingleSystemSetupParameterFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateTaskItemQaEquipmentSetupDtoToJSON(value?: CreateTaskItemQaEquipmentSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'groupId': value['groupId'],
        'name': value['name'],
        'supportSystemEntityIds': value['supportSystemEntityIds'],
        'singleSetupParameters': value['singleSetupParameters'] == null ? undefined : ((value['singleSetupParameters'] as Array<any>).map(ICreateSingleSystemSetupParameterToJSON)),
        '$type': value['$type'],
    });
}

